import { Error } from '@material-ui/icons';
import { Snackbar, Button, Grid } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

const CustomButton = styled(Button)`
  &&& {
    font-size: 0.75rem;
  }
`;

const ErrorText = styled.div`
  color: #ff4136;
  display: flex;
  align-items: center;
`;

const CustomError = styled(Error)`
  &&& {
    fill: #ff4136;
    margin-right: 0.5rem;
  }
`;
const SnackbarCustom = styled(Snackbar)`
  > div:first-of-type {
    background-color: #f8f8f8 !important;
  }
`;

const ErrorActions = ({ onCancel, onRetry, ...rest }) => {
  return (
    <Grid spacing={8} container>
      <Grid item xs={6}>
        {onCancel && typeof onCancel === 'function' ? (
          <CustomButton
            variant="contained"
            color="secondary"
            onClick={onCancel}
            {...rest}
          >
            cancel
          </CustomButton>
        ) : null}
      </Grid>
      {onRetry && typeof onRetry === 'function' ? (
        <Grid item xs={6}>
          <CustomButton
            variant="contained"
            color="secondary"
            onClick={onRetry}
            {...rest}
          >
            retry
          </CustomButton>
        </Grid>
      ) : null}
    </Grid>
  );
};

const getErrorMessage = errors => {
  const GENERIC = 'Oops! Something went wrong, please try again.';
  if (Boolean(errors)) {
    if (typeof errors === 'string') {
      return errors;
    }
    if (errors.response && errors.response.status >= 500) {
      return GENERIC;
    }
    if (errors.response && errors.response.status === 403) {
      return errors.response.data.messageDetails
    }
    if (errors.code === 'ECONNABORTED') {
      return "We couldn't get your data, please try again";
    }
    if (errors.response && errors.response.data.message) {
      return errors.response.data.message;
    } else {
      return GENERIC;
    }
  }
  return GENERIC;
};

const ErrorComp = ({ errors, onCancel, onRetry, autoHide }) => {
  return (
    <SnackbarCustom
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={Boolean(errors)}
      onClose={onCancel}
      autoHideDuration={autoHide ? 300000 : null}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
      action={
        <ErrorActions
          onCancel={!autoHide && onCancel ? onCancel : null}
          onRetry={onRetry}
        />
      }
      message={
        <ErrorText id="message-id">
          <CustomError />
          {getErrorMessage(errors)}
        </ErrorText>
      }
    />
  );
};

export default ErrorComp;
